import { useCallback, useEffect, useRef, useState } from 'react';
import {
  getQuoteDocuments,
  getQuoteFolder,
  getQuoteHistory,
  getQuoteVersions,
} from '../quote.api';

export default function useQuoteFolder() {
  const [folder, setFolder] = useState(null);
  const [folderVersions, setFolderVersions] = useState([]);
  const [folderDocuments, setFolderDocuments] = useState([]);
  const [folderHistory, setFolderHistory] = useState([]);
  const sequence = useRef(0);
  useEffect(() => () => { sequence.current += 1; }, []);

  const loadFolder = useCallback(async (quoteId) => {
    const request = ++sequence.current;
    const [folderRow, versions, documents, history] = await Promise.all([
      getQuoteFolder(quoteId),
      getQuoteVersions(quoteId),
      getQuoteDocuments(quoteId),
      getQuoteHistory(quoteId),
    ]);
    if (request !== sequence.current) return null;
    setFolder(folderRow);
    setFolderVersions(Array.isArray(versions) ? versions : []);
    setFolderDocuments(Array.isArray(documents) ? documents : []);
    setFolderHistory(Array.isArray(history) ? history : []);
    return folderRow;
  }, []);

  const clearFolder = useCallback(() => {
    sequence.current += 1;
    setFolder(null);
    setFolderVersions([]);
    setFolderDocuments([]);
    setFolderHistory([]);
  }, []);

  return {
    folder,
    setFolder,
    folderVersions,
    folderDocuments,
    folderHistory,
    loadFolder,
    clearFolder,
  };
}
